export namespace Carousel {

    export interface ITopCarousel {
        init(item: HTMLElement): void;
    }

    export class TopCarousel implements ITopCarousel {
        animateTime = 200;
        cloneItemsCount: number;

        carouselRoot: JQuery;
        nextButton: JQuery<Element>;
        prevButton: JQuery<Element>;
        itemsContainer: JQuery<Element>;
        items: JQuery<Element>;
        currentItem: number;
        autostart: number;
        moveSum = 0;
        touchStart = 0;
        working: boolean;
        hover: boolean;
        moveDone = false;
        cancelAutoplay = false;

        init(item: HTMLElement): void {
            this.hover = false;
            this.carouselRoot = $(item);
            this.autostart = $(item).data("autostart");
            this.cloneItemsCount = $(item).data("clone-items");
            if (!this.cloneItemsCount) {
                this.cloneItemsCount = 2;
            }
            
            this.nextButton = this.carouselRoot.find("[data-slide=next]");
            this.prevButton = this.carouselRoot.find("[data-slide=prev]");
            this.itemsContainer = this.carouselRoot.find("[data-container]");

            if (this.itemsContainer.children().length < 4) {
                return;
            }

            this.cloneItems();

            this.items = this.itemsContainer.children();


            this.currentItem = this.cloneItemsCount;
            this.refresh();
            this.nextButton.on("click", () => {
                this.nextButtonClick();
                this.cancelAutoplay = true;
            });

            this.prevButton.on("click", () => {
                this.prevButtonClick();
                this.cancelAutoplay = true;
            });

            this.itemsContainer.bind('touchstart', (e) => {
                this.touchStart = e.originalEvent.touches[0].clientX;
            });

            this.itemsContainer.bind('touchmove', (e) => {
                if (this.moveDone) {
                    return;
                }

                const clientX = e.originalEvent.touches[0].clientX;
                const moveX = clientX - this.touchStart;
                this.moveSum += moveX;
                this.touchStart = clientX;

                if (this.moveSum > 100) {
                    this.prevButtonClick();
                    this.moveDone = true;
                } else if (this.moveSum < -100) {
                    this.nextButtonClick();
                    this.moveDone = true;
                } else {
                    this.itemsContainer.scrollLeft(this.itemsContainer.scrollLeft() - moveX);
                }

                this.cancelAutoplay = true;
            });

            this.itemsContainer.bind('touchend', (e) => {
                this.moveSum = 0;
                if (!this.moveDone) {
                    this.refresh();
                }
                this.moveDone = false;
            });

            $(window).resize(() => {
                const newScrollPosition = this.calculateScroll();
                this.itemsContainer.scrollLeft(newScrollPosition);
            });

            this.itemsContainer.hover(() => { this.hover = true; }, () => { this.hover = false; });

            if (this.autostart) {
                this.runAuto();
            }
        }

        nextButtonClick() {
            if (this.working) {
                return;
            }

            this.currentItem = this.currentItem + 1;
            this.refresh();
        }

        runAuto() {
            if (this.cancelAutoplay) {
                return;
            }
            setTimeout(() => this.runAuto(), this.autostart);
            if (!this.hover) {
                this.nextButtonClick();
            }
        }

        prevButtonClick() {
            if (this.working) {
                return;
            }

            this.currentItem = this.currentItem - 1;
            this.refresh();
        }

        cloneItems() {
            const sourceItems = this.itemsContainer.children();
            for (let i = 0; i < this.cloneItemsCount; i++) {
                this.itemsContainer.append($(sourceItems[i]).clone());
            }
            for (let i = 0; i < this.cloneItemsCount; i++) {
                this.itemsContainer.prepend($(sourceItems[sourceItems.length - i - 1]).clone());
            }
        }

        refresh() {
            this.working = true;
            const itemIndex = this.currentItem;
            const newScroll = this.calculateScroll();
            this.itemsContainer.animate({ scrollLeft: newScroll },
                this.animateTime,
                "linear",
                () => {

                    if (itemIndex === 0) {
                        this.currentItem = this.items.length - 2 * this.cloneItemsCount;
                        const newScrollPosition = this.calculateScroll();
                        this.itemsContainer.scrollLeft(newScrollPosition);
                    }

                    if (itemIndex === this.items.length - this.cloneItemsCount - 1) {
                        this.currentItem = this.cloneItemsCount - 1;
                        const newScrollPosition = this.calculateScroll();
                        this.itemsContainer.scrollLeft(newScrollPosition);
                    }
                    this.working = false;
                });
        }

        calculateScroll(): number {
            const itemLeft = $(this.items[this.currentItem]).offset().left;
            const containerLeft = this.itemsContainer.offset().left;
            const scrollLeft = this.itemsContainer.scrollLeft();
            return itemLeft - containerLeft + scrollLeft;
        }
    }
}
